import { gql } from '@apollo/client';

const TRIGGER_WOOCOMMERCE_SYNC = gql`
  mutation TriggerWooCommerceSync($type: SyncType!) {
    TriggerWooCommerceSync(type: $type)
  }
`;

const GET_SYNC_STATUS = gql`
  query GetSyncStatus($type: SyncType!) {
    GetSyncStatus(type: $type) {
      type
      running
      lastStart
      lastEnd
    }
  }
`;

const RESET_SYNC_JOB = gql`
  mutation ResetSyncJob($type: SyncType!) {
    ResetSyncJob(type: $type)
  }
`;

export { TRIGGER_WOOCOMMERCE_SYNC, GET_SYNC_STATUS, RESET_SYNC_JOB };
